import { Col, Row } from "antd";
import Card from "common/display/Card";
import FilledButton from "common/Form/Button";
import Layout from "common/Layout";
import React, { useState, useEffect } from "react";
import { TiPlus } from "react-icons/ti";
import { useNavigate } from "react-router-dom";
import { authorizedRequest } from "api";

const Icon = () => <TiPlus style={{ marginRight: 4 }} />;

export default function Manager({ ...props }) {
  const navigate = useNavigate();
  const [nTenders, setNTenders] = useState(0);
  const [nRules, setNRules] = useState(0);

  useEffect(() => {
    authorizedRequest(`self_tenders`, {
      method: "GET",
    })
      .then(
        (success) => !!success.tenders && setNTenders(success.tenders.length)
      )
      .catch((error) => console.error(error));

    authorizedRequest(`self_rules`, {
      method: "GET",
    })
      .then((success) => !!success.rules && setNRules(success.rules.length))
      .catch((error) => console.error(error));
  }, []);

  return (
    <Layout
      headerLeftButton={{ content: "Mis proyectos", onClick: () => {} }}
      headerRightButton={{ content: "¿Cómo funciona?", onClick: () => {} }}
    >
      <Row style={{ height: "50%" }}>
        <Col xs={24}>
          <h1 className="text-center" style={{ marginBottom: 0 }}>
            Hola
          </h1>
          <h2 className="text-center">¿Qué quieres hacer?</h2>

          <Row justify="end" gutter={48} style={{ alignSelf: "bottom" }}>
            <Col lg="auto">
              <FilledButton to={"/manager/tenders/new"}>
                <Icon /> Nuevo llamado
              </FilledButton>
            </Col>
            <Col lg="auto">
              <FilledButton green to={"/manager/rules/new"}>
                <Icon /> Nueva regla
              </FilledButton>
            </Col>
          </Row>
        </Col>
      </Row>

      <Row justify="space-between" align="bottom" style={{ height: "50%" }}>
        <Col lg={10}>
          <Card
            title={nTenders + " Proyecto(s) realizado(s)"}
            actionTitle={"Ver detalles"}
            action={() => navigate("/manager/tenders")}
          />
        </Col>
        <Col lg={10}>
          <Card
            green
            title={nRules + " Regla(s) creada(s)"}
            actionTitle={"Ver detalles"}
            action={() => navigate("/manager/rules")}
          />
        </Col>
      </Row>
    </Layout>
  );
}
